export default {
  API_BASE_URL:
    (import.meta.env.VITE_API_BASE_URL as string | undefined) || 'http://localhost:3000',
  DETECTION_SERVICE_URL:
    (import.meta.env.VITE_DETECTION_SERVICE_URL as string | undefined) ||
    'http://localhost:3001',
  AUTH0: {
    DOMAIN: (import.meta.env.VITE_AUTH0_DOMAIN as string | undefined) || '',
    CLIENT_ID: (import.meta.env.VITE_AUTH0_CLIENT_ID as string | undefined) || '',
    AUDIENCE: (import.meta.env.VITE_AUTH0_AUDIENCE as string | undefined) || '',
  },
  DEMO: {
    COPY_APP_TOKEN_ENABLED:
      (import.meta.env.VITE_DEMO_COPY_APP_TOKEN_ENABLED as string | undefined) === 'true',
  },
  IDE_EXTENSION_ID:
    (import.meta.env.VITE_IDE_EXTENSION_ID as string | undefined) || 'hud.hud',
  POSTHOG: {
    KEY: (import.meta.env.VITE_PUBLIC_POSTHOG_KEY as string | undefined) || '',
    DEBUG: (import.meta.env.VITE_POSTHOG_DEBUG as string | undefined) === 'true',
    API_HOST: (import.meta.env.VITE_POSTHOG_API_HOST as string | undefined) || '',
    UI_HOST: (import.meta.env.VITE_POSTHOG_UI_HOST as string | undefined) || '',
  },
  FARO: {
    URL: (import.meta.env.VITE_FARO_URL as string | undefined) || '',
    ENVIRONMENT:
      (import.meta.env.VITE_FARO_ENVIRONMENT as string | undefined) || undefined,
  },
  WAITLIST: {
    API_URL:
      (import.meta.env.VITE_WAITLIST_API_URL as string | undefined) ||
      'https://smmx9st9g8.execute-api.eu-central-1.amazonaws.com',
  },
  SLACK: {
    CLIENT_ID: (import.meta.env.VITE_SLACK_BOT_CLIENT_ID as string | undefined) || '',
  },
};
